export const BASE_URL = 'stage-names';

export enum STAGE_NAME_TYPES {
  STAGE = 'stage',
  SUB_STAGE = 'sub_stage',
}
